export const integrations = [
    {
        type: 'NONE',
        label: 'keine Anbindung',
    },
    {
        type: 'DTA',
        label: 'Skidata-DTA',
    },
    {
        type: 'BEI',
        label: 'Skidata-BEI',
    },
    {
        type: 'AXESS',
        label: 'AXESS',
    },
];

export const smartPricerEnvironments = [
    {
        type: 'PRODUCTION',
        label: 'Production',
    },
    {
        type: 'DEVELOPMENT',
        label: 'Development',
    },
];
